import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';

const initialState = {
  reviewerdashboard:{}
};

const ReviewerDashboardSlice = createSlice({
    name: 'reviewerdashboard',
    initialState,
    reducers: {
       setReviewerDashboard(state,action)
       {
        state.reviewerdashboard=action.payload
       }
    },
});
export const ReviewerDashboardAPi = (tokendata) => async (dispatch) => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/artcle/ReviewerDashboard`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "jfdd")
            dispatch(setReviewerDashboard(res?.data))
        })
        .catch((err) => {
            console.log(err?.response, "errerrr");

        })
}



  









export const { setReviewerDashboard} = ReviewerDashboardSlice.actions;
const ReviewerDashboardReducer = ReviewerDashboardSlice.reducer;

export default ReviewerDashboardReducer;
